import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import UserContext from "../../../utils/Contexts/UserContext";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/Requests/axios";
import moment from "moment";
import chromeBrowser from "../../../images/chrome.svg";
import operaBrowser from "../../../images/opera.svg";
import safariBrowser from "../../../images/safari.svg";
import firefoxBrowser from "../../../images/firefox.svg";
import yandexBrowser from "../../../images/yandex.svg";
import edgeBrowser from "../../../images/microsoft-edge.svg";
import vivaldiBrowser from "../../../images/vivaldi.svg";
import DesktopIcon from "../../svg/desktop";
// import laptopIcon from "../../svg/laptop";
import PhoneIcon from "../../svg/phone";
import TabletIcon from "../../svg/tablet";

function RecentDevices() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const [recentDevices, setRecentDevices] = useState(null);
  const { userData } = useContext(UserContext);

  const recentDevicesFetched = useRef(false);
  const getRecentDevices = () => {
    if (recentDevicesFetched.current) return;
    const url = `analytics/users/${userData?.uuid}/visits`;
    axiosInstance
      .get(url)
      .then((response) => {
        setRecentDevices(response?.data);
        recentDevicesFetched.current = true;
      })
      .catch(() => {
        toast.error(t("There was an error fetching the recent devices"));
      });
  };

  useEffect(() => {
    getRecentDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const localizeDate = (date) => {
    const localizedDateText = moment(date)
      .tz("America/Los_Angeles")
      .format("MMM DD, YYYY, HH:mm");

    const mappings = {
      Jan: t("Jan"),
      Feb: t("Feb"),
      Mar: t("Mar"),
      Apr: t("Apr"),
      May: t("May"),
      Jun: t("Jun"),
      Jul: t("Jul"),
      Aug: t("Aug"),
      Sep: t("Sep"),
      Oct: t("Oct"),
      Nov: t("Nov"),
      Dec: t("Dec"),
    };

    return localizedDateText
      .split(" ")
      .map((word) => mappings[word] || word)
      .join(" ");
  };
  const browserIcons = {
    Chrome: chromeBrowser,
    Opera: operaBrowser,
    Safari: safariBrowser,
    Firefox: firefoxBrowser,
    Yandex: yandexBrowser,
    Edge: edgeBrowser,
    Vivaldi: vivaldiBrowser,
  };

  const getDeviceIcon = (deviceName = "") => {
    const lowerDevice = deviceName.toLowerCase();

    if (
      lowerDevice.includes("iphone") ||
      lowerDevice.includes("samsung") ||
      lowerDevice.includes("google pixel") ||
      lowerDevice.includes("huawei") ||
      lowerDevice.includes("oneplus") ||
      lowerDevice.includes("xiaomi") ||
      lowerDevice.includes("redmi") ||
      lowerDevice.includes("mi") ||
      lowerDevice.includes("motorola") ||
      lowerDevice.includes("moto")
    ) {
      return <PhoneIcon />;
    }

    if (lowerDevice.includes("ipad") || lowerDevice.includes("tablet")) {
      return <TabletIcon />;
    }

    if (
      lowerDevice.includes("mac") ||
      lowerDevice.includes("windows") ||
      lowerDevice.includes("other")
    ) {
      return <DesktopIcon />;
    }

    // fallback default
    return <DesktopIcon />;
  };

  return (
    <div
      id="RecentDevices"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4
          className="card-title responsive-title"
          style={{ fontWeight: "700" }}
        >
          {t("Recent Devices")}
        </h4>
      </div>

      <div className="card-body">
        <label
          className="form-check-label responsive-text"
          style={{ color: "var(--text-email)" }}
        >
          {t("View and manage devices where you’re currently logged in.")}
        </label>
      </div>
      <div className="table-responsive datatable-custom">
        <table
          className="table table-thead-bordered table-nowrap card-table"
          style={{ border: "transparent" }}
        >
          <thead className="thead-light">
            <tr>
              <th>{t("BROWSER")}</th>
              <th>{t("DEVICE")}</th>
              <th>{t("LOCATION")}</th>
              <th>{t("IP ADDRESS")}</th>
              <th>{t("MOST Recent activity")}</th>
            </tr>
          </thead>

          <tbody className="tbody-light">
            {!!recentDevices?.length &&
              recentDevices.map((dev, index) => {
                const deviceTime = moment(dev?.time).tz("America/Los_Angeles");
                const now = moment().tz("America/Los_Angeles");
                const isCurrent = now.diff(deviceTime, "minutes") <= 15;

                return (
                  <React.Fragment key={index}>
                    <tr className="align-middle ">
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={browserIcons[dev?.browser] || chromeBrowser}
                            alt={`${dev?.browser || "Chrome"} icon`}
                          />
                          {dev?.browser} {t("on")} {dev?.platform}
                        </div>
                      </td>
                      <td className="d-flex">
                        <div className="d-flex align-items-center gap-2">
                          {getDeviceIcon(dev?.device)}
                          {dev?.device}
                          {isCurrent && (
                            <span
                              className="badge ms-2 d-flex align-items-center justify-content-center"
                              style={{
                                backgroundColor: "rgba(2, 201, 166, 0.1)",
                                height: "23px",
                                width: "51px",
                                fontSize: "12px",
                                color: "rgba(2, 201, 166, 1)",
                              }}
                            >
                              {t("Current")}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>{dev?.location}</td>
                      <td>{dev?.ip4}</td>
                      <td>{isCurrent ? "Now" : localizeDate(dev?.time)}</td>
                    </tr>

                    {index !== recentDevices.length - 1 && (
                      <tr>
                        <td
                          colSpan="100%"
                          className="px-3 py-0"
                          style={{ border: "transparent" }}
                        >
                          <div
                            style={{
                              width: "calc(100% - 2px)",
                              height: "2px",
                              backgroundColor:
                                selectedTheme === "dark"
                                  ? "rgba(45, 50, 54, 1)"
                                  : "rgba(45, 50, 54, 0.2)",
                              margin: "0 auto",
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RecentDevices;
